export default "__VITE_ASSET__zWI0XGM4__"